import {
  STATUS_NOT_FOUND,
  STATUS_SERVER_ERROR,
  STATUS_UNAUTHORIZED
} from '~/constants/http'
import useCustomToast from '~/components/EFToastContent/useCustomToast'

export function ErrorHandler(statusCode: number) {
  const { showErrorToast } = useCustomToast()

  switch (statusCode) {
    case STATUS_NOT_FOUND:
      // window.location.href = '/NotFound'
      break

    case STATUS_SERVER_ERROR:
      showErrorToast('Server Error')
      break

    case STATUS_UNAUTHORIZED:
      window.location.href = '/login'
      localStorage.removeItem('user')
      break
    default:
      break
  }
}
